import React from 'react'
import { Routes, Route, HashRouter } from 'react-router-dom'

import App, {
  VIEW_STATE_POOLS,
  VIEW_STATE_DEPOSIT,
  VIEW_STATE_TRADE,
  VIEW_STATE_WITHDRAW,
} from './App'
import { Web3Provider } from '../hooks/web3'
import { reactEndpoints } from '../api/react-endpoint'
import { configureEndpoints } from '../api/subgraph/graph-client'
import { ReloadProvider } from '../hooks/use-reload'
import { PoolsProvider } from '../hooks/use-pools'
import { TransactionProvider } from '../components/transactions/TransactionContext'
import { AccountStateProvider } from '../hooks/useAccountState'

const Launcher = () => {
  return (
    <Web3Provider>
      <TransactionProvider>
        <ReloadProvider>
          <AccountStateProvider>
            <PoolsProvider>
              <HashRouter>
                <Routes>
                  <Route path="/" element={<App page={VIEW_STATE_POOLS} />} />
                  <Route
                    path="/pools"
                    element={<App page={VIEW_STATE_POOLS} />}
                  />
                  <Route
                    path="/pools/:poolId/deposit"
                    element={<App page={VIEW_STATE_DEPOSIT} />}
                  />
                  <Route
                    path="/pools/:poolId/withdraw"
                    element={<App page={VIEW_STATE_WITHDRAW} />}
                  />
                  <Route
                    path="/swap"
                    element={<App page={VIEW_STATE_TRADE} />}
                  />
                </Routes>
              </HashRouter>
            </PoolsProvider>
          </AccountStateProvider>
        </ReloadProvider>
      </TransactionProvider>
    </Web3Provider>
  )
}

if (!reactEndpoints.subgraph) {
  console.warn('No subgraph client set in .env file')
} else {
  configureEndpoints(reactEndpoints)
}

export default Launcher
